export enum InfoNotificationStatus {
    Archive = 0,
    Read = 1
}
